<div class="filter-item  d-flex justify-content-between">
    <label class="label text-end">Price</label>
    <div class="btn-group w-200px" role="group" aria-label="Filter By Price">
        <button class="btn bg-default btn-color btn-just-icon" [ngClass]="{'active-btn': price.checked}"
            *ngFor="let price of prices; index as indx; last as isLast" [ngClass]="{'me-0': isLast}"
            (click)="togglePrices(indx)" [title]="price.hint">
            {{price.symbol}}
        </button>
    </div>
</div>